import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import AnnouncementListItem from "./announcement-list-item";

export default class AnnouncementList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortBy: 'creationDate',
            sortDirection: 'asc'
        }

        this.onTableHeaderClick = this.onTableHeaderClick.bind(this);
    }

    onTableHeaderClick(event) {
        var id = event.target.id;
        var direction = 'asc';

        if (this.state.sortBy == id) {
            if (this.state.sortDirection == 'asc') {
                direction = 'desc';
            }
            else {
                direction = 'asc';
            }
        }

        this.setState({
            sortBy: id,
            sortDirection: direction
        });

        function compare(value1, value2) {
            if (value1 < value2)
                return -1;
            if (value1 > value2)
                return 1;
            return 0;
        }

        if (direction == 'asc') {
            switch (id) {
                case 'announcementId': 
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.announcementId, obj2.announcementId);
                    });
                    break;
                case 'header':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.header, obj2.header);
                    });
                    break;
                case 'sticky':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.sticky, obj2.sticky);
                    });
                    break;
                case 'linkType':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.linkType, obj2.linkType);
                    });
                    break;
                case 'linkId':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.linkId, obj2.linkId);
                    });
                    break;
                case 'groupBy':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.groupBy, obj2.groupBy);
                    });
                    break;
                case 'startDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.startDate, obj2.startDate);
                    });
                    break;
                case 'endDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.endDate, obj2.endDate);
                    });
                    break;
                case 'newIcon':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.newIcon, obj2.newIcon);
                    });
                    break;
                case 'creationDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.creationDate, obj2.creationDate);
                    });
                    break;
                case 'creationOperator':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.creationOperator, obj2.creationOperator);
                    });
                    break;
                case 'modifyDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyDate, obj2.modifyDate);
                    });
                    break;
                case 'modifyOperator':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj1.modifyOperator, obj2.modifyOperator);
                    });
                    break;
            }
        }
        else {
            switch (id) {
                case 'announcementId': 
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.announcementId, obj1.announcementId);
                    });
                    break;
                case 'header':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.header, obj1.header);
                    });
                    break;
                case 'sticky':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.sticky, obj1.sticky);
                    });
                    break;
                case 'linkType':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.linkType, obj1.linkType);
                    });
                    break;
                case 'linkId':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.linkId, obj1.linkId);
                    });
                    break;
                case 'groupBy':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.groupBy, obj1.groupBy);
                    });
                    break;
                case 'startDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.startDate, obj1.startDate);
                    });
                    break;
                case 'endDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.endDate, obj1.endDate);
                    });
                    break;
                case 'newIcon':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.newIcon, obj1.newIcon);
                    });
                    break;
                case 'creationDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.creationDate, obj1.creationDate);
                    });
                    break;
                case 'creationOperator':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.creationOperator, obj1.creationOperator);
                    });
                    break;
                case 'modifyDate':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyDate, obj1.modifyDate);
                    });
                    break;
                case 'modifyOperator':
                    this.props.announcements.sort(function(obj1, obj2) { 
                        return compare(obj2.modifyOperator, obj1.modifyOperator);
                    });
                    break;
            }
        }

        if (this.props.onChange) {
            this.props.onChange(this.props.announcements);
        }
    }

    render() {
        var items = [];

        if (this.props.announcements.length > 0) {
            for (var i = 0; i < this.props.announcements.length; i++) {
                let dataItem = this.props.announcements[i];
                items.push(
                    <AnnouncementListItem vm={dataItem} noLabel={this.props.noLabel} yesLabel={this.props.yesLabel}></AnnouncementListItem>
                );
            }
        }

        return (
            <div className={this.props.announcements.length > 0 ? "" : "ap-hidden"}>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td onClick={this.onTableHeaderClick} id="announcementId">ID</td>
                                    <td onClick={this.onTableHeaderClick} id="header">Header</td>
                                    <td onClick={this.onTableHeaderClick} id="sticky">Sticky</td>
                                    <td onClick={this.onTableHeaderClick} id="linkType">LinkType</td>
                                    <td onClick={this.onTableHeaderClick} id="linkId">LinkID</td>
                                    <td onClick={this.onTableHeaderClick} id="groupBy">GroupBy</td>
                                    <td onClick={this.onTableHeaderClick} id="startDate">StartDate</td>
                                    <td onClick={this.onTableHeaderClick} id="endDate">EndDate</td>
                                    <td onClick={this.onTableHeaderClick} id="newIcon">New</td>
                                    <td onClick={this.onTableHeaderClick} id="creationDate">Created Date</td>
                                    <td onClick={this.onTableHeaderClick} id="creationOperator">Created By</td>
                                    <td onClick={this.onTableHeaderClick} id="modifyDate">Modified Date</td>
                                    <td onClick={this.onTableHeaderClick} id="modifyOperator">Modify By</td>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}